
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUserProfile } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(null);

  const mutation = useMutation({
    mutationFn: async (newData) => {
      try {
        return await updateUserProfile(newData);
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    onSuccess: () => {
      setSuccess("تم تحديث الملف الشخصي بنجاح ");
      
      queryClient.invalidateQueries({ queryKey: ["userProfile"] });
    },
    onError: () => {
      setErrors({ submit: "فشل تحديث الملف الشخصي " });
    },
  });

  const handleChange = (e) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    setSuccess(null);
    mutation.mutate(fields);
  };

  const setFieldsFromProfile = (profile) => {
    setFields(profile || {});
  };

  return {
    fields,
    errors,
    loading: mutation.isLoading,
    error: mutation.error,
    success,
    handleChange,
    handleSubmit,
    setFieldsFromProfile,
    clearError: () => setErrors({}),
    clearSuccess: () => setSuccess(null),
    updateProfile: mutation.mutate,
  };
};

export default useUpdateProfile;















  

































































































